/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScorecardResult } from './ScorecardResult.js';
import {
    ScorecardResultFromJSON,
    ScorecardResultFromJSONTyped,
    ScorecardResultToJSON,
} from './ScorecardResult.js';

/**
 * 
 * @export
 * @interface GetScorecardResultResponse
 */
export interface GetScorecardResultResponse {
    /**
     * 
     * @type {ScorecardResult}
     * @memberof GetScorecardResultResponse
     */
    data?: ScorecardResult;
    /**
     * 
     * @type {number}
     * @memberof GetScorecardResultResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetScorecardResultResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetScorecardResultResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetScorecardResultResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetScorecardResultResponse interface.
 */
export function instanceOfGetScorecardResultResponse(value: object): boolean {
    return true;
}

export function GetScorecardResultResponseFromJSON(json: any): GetScorecardResultResponse {
    return GetScorecardResultResponseFromJSONTyped(json, false);
}

export function GetScorecardResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetScorecardResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ScorecardResultFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetScorecardResultResponseToJSON(value?: GetScorecardResultResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ScorecardResultToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

